import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  
  return getRequest(`company/get-list/${parseInt(size, 10) || 10}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  return getRequest(`company/edit/${id}`)
}

export async function save(values) {
  return postRequest(`company/save`, values)
}

export function remove(values) {
  return postRequest(`company/delete`, values)
}
